import { defineComponent as _defineComponent } from 'vue'
import type { GoingViralSpotlightModuleFragment } from '@/features/onboarded-home/types';

import SpotlightModuleWithHorizontalScroll from '@/features/onboarded-home/components/modules/spotlights/SpotlightModuleWithHorizontalScroll.vue';
import GoingViralSpotlightModuleCard from '@/features/onboarded-home/components/modules/spotlights/GoingViralSpotlightModuleCard.vue';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoingViralSpotlightModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: GoingViralSpotlightModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	titleSize: () => props.moduleData.titles.length,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, SpotlightModuleWithHorizontalScroll, GoingViralSpotlightModuleCard }
}

})